// 支持读取的格式
export var SupportedReadingFormats = ['png', 'jpg', 'jpeg', 'webp', 'tiff'];

// 支持写入的格式
export var SupportedWritingFormats = ['png', 'jpg', 'jpeg', 'webp', 'avif'];

// https://avif.io/blog/tutorials/css/#avifsupportdetectionscript
export function detectAvifScript() {
  var avif_class = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'avifok';
  return "function addClass(className) {\n    document.documentElement.classList.add(className);\n   }\n   var avif = new Image();\n   avif.src =\n    \"data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=\";\n   avif.onload = function () {\n    addClass(\"".concat(avif_class, "\");\n   };");
}
export function detectWebpScript() {
  var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'webpok';
  return "\n  var isWebp = document.createElement(\"canvas\").toDataURL(\"image/webp\").includes(\"data:image/webp\");\n  if(isWebp) {\n    document.documentElement.classList.add(\"".concat(className, "\");\n  }\n  ");
}
export function loadDetectScript() {
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.innerHTML = "\n    ".concat(detectAvifScript(), "\n    ").concat(detectWebpScript(), "\n    ");
    // 不会执行onload
    // script.onload = () => {
    //   resolve(true);
    // };
    script.onerror = function () {
      reject(false);
    };
    document.body.appendChild(script);
    setTimeout(function () {
      resolve(true);
    }, 1);
  });
}
export function isSupportAvif() {
  if (typeof window === 'undefined') return false;
  return document.documentElement.classList.contains('avifok');
}
export function isSupportWebp() {
  if (typeof window === 'undefined') return true;
  return document.documentElement.classList.contains('webpok');
}